module.exports = __webpack_public_path__ + "static/media/banner-jain.466d4dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/banner-jain.jpg
// module id = 1013
// module chunks = 0